import request from '../utils/request'


// 客户登录接口
export const UserLogin = (data) => {
    return request({
      url: 'user/login',
      method: 'post',
      data,
    })
  }

// 客户注册接口 
export const UserRegister = (data) => {
    return request({
      url: 'user/register',
      method: 'post',
      data,
    })
  }

  // 短信验证接口 
  export const GetPhoneCode = (data) => {
    return request({
      url: 'sms/verificationCode',
      method: 'get',
      params:data,
    })
  }

// 微信登陆接口 
export const UserWxlogin = (data) => {
  return request({
    url: 'user/wxlogin',
    method: 'post',
    data,
  })
}

//获取销售
export const GetSysSale = (data) => {
  return request({
    url: 'sysUser/sales',
    method: 'get',
    params:data,
  })
}

//  发送邮箱验证码数据
export const GetSecurityEmail = (data) => {
  return request({
    url: 'email/emailCode',
    method: 'get',
    params:data,
  })
}

// 未读消息 
export const GetunReadMessage = (data) => {
  return request({
    url: 'message/unReadMessage',
    method: 'get',
    params:data,
  })
}

// 子账号登陆 user/loginSub
export const UserSubLogin = (data) => {
  return request({
    url: 'user/loginSub',
    method: 'post',
    data,
  })
}

// 微信选择账号登陆
export const wxAppLoginUser = (data) => {
  return request({
    url: 'user/wxApploginUser',
    method: 'post',
    data,
  })
}

// 提交反馈 user/questionnaire
export const GetQuestionnaire = (data) => {
  return request({
    url: 'user/questionnaire',
    method: 'post',
    data,
  })
}

// ai助手 
// export const GetAiChatStream = (data) => {
//   return request({
//     url: 'ai/chat/streams',
//     method: 'post',
//     data,
//     params: { hideLoading: true }
//   })
// }

// export const GetAiChatStream = (data,hideLoading = false) => {
//   return request({
//     url: 'ai/chat/streams/'+data,
//     method: 'get',
//     params: { hideLoading },
//   })
// }

// ai随机问题 
export const GetAiChat = (data) => {
  return request({
    url: 'ai/chat',
    method: 'post',
    data,
    params: { hideLoading: true }
  })
}